export default {
  // Commission Config
  'pages.commissionConfig.title': 'Commission Configuration',
  'pages.commissionConfig.levelTable.title': 'S-Level Configuration',
  'pages.commissionConfig.col.level': 'Level',
  'pages.commissionConfig.col.threshold': 'Threshold (USDT)',
  'pages.commissionConfig.col.rate': 'Level Diff Rate (%)',
  'pages.commissionConfig.directRate': 'Direct Referral Rate',
  'pages.commissionConfig.directRate.desc': 'Default rate for direct referral rewards',
  'pages.commissionConfig.save': 'Save Configuration',
  'pages.commissionConfig.saving': 'Saving...',
  'pages.commissionConfig.recalculate': 'Recalculate All Performance',
  'pages.commissionConfig.recalculate.confirm': 'Are you sure you want to recalculate all user performance data? This may take a long time.',
  'pages.commissionConfig.msg.loadFail': 'Failed to load configuration',
  'pages.commissionConfig.msg.saveSuccess': 'Configuration saved successfully',
  'pages.commissionConfig.msg.saveFail': 'Failed to save configuration',
  'pages.commissionConfig.msg.recalcSuccess': 'Performance recalculation started',
  'pages.commissionConfig.msg.recalcFail': 'Failed to start performance recalculation',
  'pages.commissionConfig.refresh': 'Refresh',

  // Commission Records
  'pages.commissionRecords.title': 'Commission Records',
  'pages.commissionRecords.col.time': 'Time',
  'pages.commissionRecords.col.beneficiary': 'Beneficiary',
  'pages.commissionRecords.col.triggerUser': 'Trigger User',
  'pages.commissionRecords.col.rewardType': 'Reward Type',
  'pages.commissionRecords.col.baseAmount': 'Purchase Amount',
  'pages.commissionRecords.col.rate': 'Rate',
  'pages.commissionRecords.col.amount': 'Commission (USDT)',
  'pages.commissionRecords.col.status': 'Status',
  'pages.commissionRecords.filter.userId': 'Filter by user ID or wallet address',
  'pages.commissionRecords.filter.rewardType': 'Reward Type',
  'pages.commissionRecords.filter.status': 'Status',
  'pages.commissionRecords.filter.direct': 'Direct Referral',
  'pages.commissionRecords.filter.levelDiff': 'Level Difference',
  'pages.commissionRecords.filter.pending': 'Pending',
  'pages.commissionRecords.filter.credited': 'Credited',
  'pages.commissionRecords.filter.failed': 'Failed',
  'pages.commissionRecords.search': 'Search',
  'pages.commissionRecords.refresh': 'Refresh',
  'pages.commissionRecords.total': '{total} records',
  'pages.commissionRecords.stats.totalCommissions': 'Total Commissions (USDT)',
  'pages.commissionRecords.stats.totalCount': 'Total Count',
  'pages.commissionRecords.stats.directTotal': 'Direct Referral Total',
  'pages.commissionRecords.stats.levelDiffTotal': 'Level Diff Total',
  'pages.commissionRecords.msg.loadFail': 'Failed to load commission records',

  // Team Performance
  'pages.teamPerformance.title': 'Team Performance',
  'pages.teamPerformance.search.placeholder': 'Enter user ID or wallet address',
  'pages.teamPerformance.search': 'Query',
  'pages.teamPerformance.userInfo': 'User Information',
  'pages.teamPerformance.userInfo.level': 'Current Level',
  'pages.teamPerformance.userInfo.totalPerformance': 'Total Performance (USDT)',
  'pages.teamPerformance.userInfo.largeArea': 'Large Area (USDT)',
  'pages.teamPerformance.userInfo.smallArea': 'Small Area (USDT)',
  'pages.teamPerformance.earnings': 'Earnings Information',
  'pages.teamPerformance.earnings.total': 'Total Earnings (USDT)',
  'pages.teamPerformance.earnings.direct': 'Direct Earnings (USDT)',
  'pages.teamPerformance.earnings.levelDiff': 'Level Diff Earnings (USDT)',
  'pages.teamPerformance.earnings.pending': 'Pending (USDT)',
  'pages.teamPerformance.userInfo.wallet': 'Wallet',
  'pages.teamPerformance.userInfo.directCount': 'Direct Referrals',
  'pages.teamPerformance.teamSize': 'Team Size',
  'pages.teamPerformance.levelDist': 'Level Distribution',
  'pages.teamPerformance.tab.tree': 'Team Tree',
  'pages.teamPerformance.tab.table': 'Member Table',
  'pages.teamPerformance.tree.perf': 'Perf',
  'pages.teamPerformance.tree.empty': 'No team members',
  'pages.teamPerformance.col.wallet': 'Wallet',
  'pages.teamPerformance.col.level': 'Level',
  'pages.teamPerformance.col.depth': 'Depth',
  'pages.teamPerformance.col.depthLv': 'Lv{val}',
  'pages.teamPerformance.col.performance': 'Performance',
  'pages.teamPerformance.col.smallArea': 'Small Area',
  'pages.teamPerformance.col.earnings': 'Earnings',
  'pages.teamPerformance.col.direct': 'Direct',
  'pages.teamPerformance.col.custody': 'Custody',
  'pages.teamPerformance.col.yes': 'Yes',
  'pages.teamPerformance.col.no': 'No',
  'pages.teamPerformance.changeLevel': 'Change Level',
  'pages.teamPerformance.changeLevel.title': 'Change User Level',
  'pages.teamPerformance.changeLevel.label': 'New Level',
  'pages.teamPerformance.msg.loadFail': 'Query failed',
  'pages.teamPerformance.msg.levelChangeSuccess': 'Level changed successfully',
  'pages.teamPerformance.msg.levelChangeFail': 'Failed to change level',
  'pages.teamPerformance.msg.inputUserId': 'Please enter a user ID or wallet address',
  'pages.teamPerformance.customRate': 'Custom Rate',
  'pages.teamPerformance.customRate.title': 'Custom Commission Rate',
  'pages.teamPerformance.customRate.levelDiff': 'Level-Diff Rate (%)',
  'pages.teamPerformance.customRate.custom': 'Custom',
  'pages.teamPerformance.customRate.global': 'Global',
  'pages.teamPerformance.customRate.direct': 'Direct Referral Rate (%)',
  'pages.teamPerformance.customRate.remark': 'Remark',
  'pages.teamPerformance.customRate.remarkPlaceholder': 'Reason for custom rate',
  'pages.teamPerformance.msg.customRateSuccess': 'Custom rate updated',
  'pages.teamPerformance.msg.customRateFail': 'Failed to update custom rate',
  'pages.teamPerformance.userInfo.customRate': 'Custom Level-Diff Rate',
  'pages.teamPerformance.userInfo.customDirectRate': 'Custom Direct Rate',
  'pages.teamPerformance.userInfo.customRateRemark': 'Rate Remark',
  'pages.teamPerformance.changeLevel.auto': 'Auto',
};
